<template>
  <div>
    <div class="clearfix yx_contentbox">
      <!--课程科目为空的时候上部分S-->
      <div class="clearfix">
        <div class="fl yx_classleftbox">
          <div class="clearfix yx_classtitbox bbcolor" :class="xueqianShow ? '' : 'bbcolor'">
            <h3 class="fl yx_classtit">幼儿</h3>
            <ul class="fl yx_titlist" v-if="xueqianShow">
              <li :class="xueqianIndex === 0 ? 'yxempty_titliston' : ''" v-show="xueqian.yingyu.length === 3" data-index=0 @click="xueqianChange(0)">英语</li>
              <li :class="xueqianIndex === 1 ? 'yxempty_titliston' : ''" v-show="xueqian.duoyuan.length === 3" data-index=1 @click="xueqianChange(1)">幼儿多元智能</li>
            </ul>
          </div>

          <div class="clearfix yx_classggbox" v-if="xueqianShow">
            <div class="fl yx_classgg">
              <img src="http://file.xdf.cn/neworiental/images/yx_classgg1.png?1903" alt="">
            </div>
            <ul class="fl yx_classlist" v-show="xueqianIndex === 0">
              <a class="fl" v-for="(item, index) in xueqian.yingyu" :key="index" :href="`http://souke.xdf.cn/Class/${$store.state.soukecityId}-${item.Id}.html`">
                <div class="yx_classimg">
                  <img :src="getTeacher(item.TeacherList).NewLogoUrl">
                </div>
                <p class="yx_classname">{{getTeacher(item.TeacherList).Name}}</p>
                <h4 class="guess_titilesmall">{{item.FullName}}</h4>
                <p class="clearfix mb10">
                  <span class="fl guess_adressicon"></span>
                  <span class="fl guess_adress">{{item.LearnPlace}}</span>
                </p>
                <p class="clearfix mb10">
                  <span class="fl guess_timeicon"></span>
                  <span class="fl guess_adress">{{getLearnTime(item.StartDate)}}</span>
                </p>
                <p class="guess_money mt0 fl"><span>￥</span>{{item.Price}}</p>
              </a>
            </ul>
            <ul class="fl yx_classlist" v-show="xueqianIndex === 1">
              <a class="fl" v-for="(item, index) in xueqian.duoyuan" :key="index" :href="`http://souke.xdf.cn/Class/${$store.state.soukecityId}-${item.Id}.html`">
                <div class="yx_classimg">
                  <img :src="getTeacher(item.TeacherList).NewLogoUrl">
                </div>
                <p class="yx_classname">{{getTeacher(item.TeacherList).Name}}</p>
                <h4 class="guess_titilesmall">{{item.FullName}}</h4>
                <p class="clearfix mb10">
                  <span class="fl guess_adressicon"></span>
                  <span class="fl guess_adress">{{item.LearnPlace}}</span>
                </p>
                <p class="clearfix mb10">
                  <span class="fl guess_timeicon"></span>
                  <span class="fl guess_adress">{{getLearnTime(item.StartDate)}}</span>
                </p>
                <p class="guess_money mt0 fl"><span>￥</span>{{item.Price}}</p>
              </a>
            </ul>
          </div>

          <!--数据为空S-->
          <div class="yx_emptybox" v-else>
            <div class="yx_emptyimgword">
              <div class="yx_emptyimg">
                <img src="http://file.xdf.cn/neworiental/images/yx_emptyimg1.png">
              </div>
              <p class="yx_emptyimgword1">在泡泡课堂上，教师通过绘本教材和多媒体的教学模式让孩子开始英语学习。</p>
              <p class="yx_emptyimgword2">引发孩子将绘本中的画面、情节、单词、句型、语音存储在大脑中的不同区域。</p>
              <p class="yx_emptyimgword3">老师引导孩子对绘本进行观察、想象并组织语言，这些绘本的语言知识与孩子们脑海中旧有的相同场景进行链接，激活旧有认知，让孩子感觉头脑一亮！</p>
              <p class="yx_emptyimgword4">你会发现孩子能够在不经意间将成段的英文表达出来。</p>
              <p class="yx_emptyimgword5">时间长了，孩子会逐渐养成自主阅读学习的习惯，包括朗读英文绘本故事、口语交流、自主阅读绘本等等，孩子再也离不开他的绘本了。</p>
            </div>
          </div>
          <!--数据为空E-->

        </div>
        <zixun title="兴趣资讯" typeids=4344 :cow="xueqianShow ? 4 : 5"></zixun>
      </div>
      <!--课程科目为空的时候上部分E-->
    </div>

    <div class="clearfix yx_contentbox">
      <!-- 课程科目为空的时候下部分S -->
      <div class="fl yx_classleftbox">
        <div class="clearfix yx_classtitbox bbcolor">
          <h3 class="fl yx_classtit">小学</h3>
          <ul class="fl yx_titlist" v-if="xiaoxueShow">
            <li
              class="fl"
              :class='index === xiaoxueIndex ? "yxempty_titliston" : ""'
              @click="xiaoxueChange(index)"
              v-for="(item, index) in xiaoxue"
              :key="index"
            >{{getGrade(item.grade + 1)}}年级</li>
          </ul>
          <ul class="fl yx_titlist" v-else>
            <li class="fl" :class='nodataCheck === 0 ? "yxempty_titliston" : ""' @click="changeSub(0)">英语</li>
            <li class="fl" :class='nodataCheck === 1 ? "yxempty_titliston" : ""' @click="changeSub(1)">数学</li>
            <li class="fl" :class='nodataCheck === 2 ? "yxempty_titliston" : ""' @click="changeSub(2)">语文</li>
          </ul>
        </div>

        <div class="clearfix yx_classggbox" v-if="xiaoxueShow">
          <div class="fl yx_classgg">
            <img src="http://file.xdf.cn/neworiental/images/yx_classgg2.png?1903" alt="">
          </div>
          <ul
            class="fl yx_classlist"
            v-for="(grade, gradeIndex) in xiaoxue"
            :key="gradeIndex"
            data-index="gradeIndex"
            v-show="gradeIndex === xiaoxueIndex"
          >
            <a class="fl" v-for="(item, index) in xiaoxue[gradeIndex]" :key="index" :href="`http://souke.xdf.cn/Class/${$store.state.soukecityId}-${item.Id}.html`">
              <div class="yx_classimg">
                <img :src="getTeacher(item.TeacherList).NewLogoUrl">
              </div>
              <p class="yx_classname">{{getTeacher(item.TeacherList).Name}}</p>
              <h4 class="guess_titilesmall">{{item.FullName}}</h4>
              <p class="clearfix mb10">
                <span class="fl guess_adressicon"></span>
                <span class="fl guess_adress">{{item.LearnPlace}}</span>
              </p>
              <p class="clearfix mb10">
                <span class="fl guess_timeicon"></span>
                <span class="fl guess_adress">{{getLearnTime(item.StartDate)}}</span>
              </p>
              <p class="guess_money mt0 fl"><span>￥</span>{{item.Price}}</p>
            </a>
          </ul>
        </div>
      </div>
      <!-- 课程科目为空的时候资讯S -->
      <zixun title="小学资讯" typeids=1266 :cow="xiaoxueShow ? 4 : 5"></zixun>
      <!-- 课程科目为空的时候资讯E -->
      <!-- 课程科目为空的时候下部分S -->
    </div>
  </div>
</template>

<script>
import Zixun from './Zixun'
import {getClassBySearch} from 'js/getSoukeData.js'
export default {
  name: 'Mainfloor',
  data () {
    return {
      nodataCheck: 0,
      xueqian: {
        yingyu: [],
        duoyuan: []
      },
      xiaoxue: [],
      xueqianIndex: 0,
      xiaoxueIndex: 0,
      xueqianShow: false,
      xiaoxueShow: false
    }
  },
  components: {
    Zixun
  },
  computed: {
    getLearnTime (time) {
      return function (time) {
        if (time) {
          return time.split('T')[0]
        }
      }
    },
    getTeacher (teacherArr) {
      return function (teacherArr) {
        if (teacherArr !== '') {
          return {NewLogoUrl: 'http://file.xdf.cn/neworiental/images/teacherImgOneToOne.png', Name: '待定'}
        } else {
          return {
            NewLogoUrl: `http://img.xdf.cn/TeacherIMG/${teacherArr.NewLogoUrl}`,
            Name: teacherArr.Name
          }
        }
      }
    },
    cityId () {
      return this.$store.state.soukecityId
    },
    getGrade (grade) {
      return function (grade) {
        switch (grade) {
          case 1:
            return '一'
          case 2:
            return '二'
          case 3:
            return '三'
          case 4:
            return '四'
          case 5:
            return '五'
          case 6:
            return '六'
        }
      }
    }
  },
  created () {
    let _this = this
    try {
      getClassBySearch(this.$store.state.soukecityId, 3, 324, 0).then(function (response) {
        _this.$nextTick(() => {
          if (response.ClassList.length === 3) {
            _this.xueqianShow = true
            _this.xueqianIndex = 0
            _this.xueqian.yingyu = response.ClassList
          }
          getClassBySearch(_this.$store.state.soukecityId, 3, 323, 0).then(function (response) {
            _this.$nextTick(() => {
              if (response.ClassList.length === 3) {
                if (!_this.xueqianShow) {
                  _this.xueqianShow = true
                  _this.xueqianIndex = 1
                }
                _this.xueqian.duoyuan = response.ClassList
              }
            })
          })
        })
      })
      this.getPrimaryData(9, [])
    } catch (e) {
      console.log(e)
    }
  },
  methods: {
    changeSub (index) {
      this.nodataCheck = index
    },
    xueqianChange (index) {
      this.xueqianIndex = index
    },
    xiaoxueChange (index) {
      this.xiaoxueIndex = index
    },
    getPrimaryData (cnt, attr) {
      let _this = this
      let index = cnt - 9
      if (cnt > 14) {
        this.xiaoxue = attr
      } else {
        if (_this.xiaoxue[index] === undefined) {
          _this.xiaoxue[index] = []
        }
        getClassBySearch(this.$store.state.soukecityId, 3, 40, cnt).then(function (response) {
          if (response.ClassList.length === 3) {
            if (!_this.xiaoxueShow) {
              _this.xiaoxueIndex = 0
              _this.xiaoxueShow = true
            }
            response.ClassList.grade = index
            attr.push(response.ClassList)
          }
          cnt++
          _this.getPrimaryData(cnt, attr)
        }).catch(function () {
          cnt++
          _this.getPrimaryData(cnt, attr)
        })
      }
    }
  },
  watch: {
    xiaoxue () {
      return this.xiaoxue
    },
    cityId (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.xiaoxueIndex = 0
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl'
.fl
  float: left
.fr
  float: right
.mb10
  margin-bottom: 7px
.clear:after
  content: ''
  display: block
  clear: both
.clearfix:after
  display: block
  content: ""
  clear: both
.yx_contentbox
  width: 1200px
  margin: 50px auto
  .yx_classleftbox
    width:934px
    .yx_classtitbox
      width: 934px
      height: 36px
      line-height: 36px
      border-bottom: 1px solid #dee1e9
      .yx_classtit
        width: 196px
        font-size: 22px
        color: #333
        margin-right: 10px
      .yx_titlist
        li
          height: 36px
          line-height: 36px
          padding: 0 28px
          float: left
          border-left: 1px solid #fff
          border-right: 1px solid #fff
          font-size: 16px
          color: #333333
          cursor: pointer
        .yx_titliston
          color: #31A893
          border-bottom: 1px solid #31A893
      .yx_morebtn
        font-size: 14px
        color: #31a893
        background: url(http://file.xdf.cn/neworiental/images/yx_indexbg.png?190315) no-repeat 7px -170.5px
        padding-right: 10px
    .bbcolor
      border-bottom: 2px solid #a5e1d6
    .yx_classggbox
      margin-top: 16px
      .yx_classgg
        width: 193px
        height: 327px
        img
          width:100%
          height:100%
      .yx_classlist
        width: 740px
        a
          display: block
          width: 236px
          height: 327px
          background: #f7f9fb
          padding: 28px 16px
          box-sizing: border-box
          margin-left: 10px
          &:hover
            box-shadow: 1px 5px 10px 1px #e5e5e5
            background:#fff
            .guess_titilesmall
              color: #00b388
          .yx_classimg
            width: 114px
            height: 114px
            margin: 0 auto
            border-radius: 50%
            overflow: hidden
            img
              width: 100%
              height: 100%
          p
            .guess_adressicon
              display: inline-block
              width: 12px
              height: 14px
              background: url(http://images.xdf.cn/cms20150819/zuixinban/images/adress.png) no-repeat
              margin-top: -1px
              margin-right:5px
            .guess_adress
              width: 80%
              color: #9c9c9c
              font-size: 12px
              overflow: hidden
              white-space: nowrap
            .guess_timeicon
              display: inline-block
              width: 12px
              height: 12px
              background: url(http://images.xdf.cn/cms20150819/zuixinban/images/guess_time.png) no-repeat
              margin-right: 5px
              margin-top: -1px;
          .yx_classname
            width: 100%
            text-align: center
            font-size: 20px
            color: #333333
            margin-top: 15px
            margin-bottom: 31px
          .guess_titilesmall
            font-size: 14px
            color: #3f3f3f
            margin-bottom: 13px
            display: block
            width: 183px
            overflow: hidden
            white-space: nowrap
          .guess_money
            color: #ff7011
            font-size: 19px
            margin-top:10px
            span
              font-size: 14px
    .yx_emptybox
      width: 100%
      font-size: 13px
      text-align: center
      margin-top: 57px
      .yx_emptyimgword
        position: relative
        width: 100%
        height: 410px
        color: #2db6e7
        text-align: left
        .yx_emptyimg
          width: 880px
          height: 267px
          margin-top: 38px
          img
            width: 100%
            height: 100%
        p
          width: 156px
          line-height: 18px
          position: absolute
        .yx_emptyimgword1
          top: 281px
          left: 16px
        .yx_emptyimgword2
          top: 278px
          left: 231px
        .yx_emptyimgword3
          top: 246px
          left: 435px
          width: 181px
        .yx_emptyimgword4
          top: 27px
          left: 776px
          width: 118px
        .yx_emptyimgword5
          top: 257px
          left: 670px
          width: 167px
    .yx_classtitbox
      width: 934px
      height: 36px
      line-height: 36px
      border-bottom: 1px solid #dee1e9
    .bbcolor
      border-bottom: 2px solid #98dfd2
      .yx_classtit
        width: 194px
        font-size: 22px
        color: #333
        margin-right: 10px
      .yx_titlist
        li
          height: 36px
          line-height: 36px
          padding: 0 28px
          float: left
          border-left: 1px solid #fff
          border-right: 1px solid #fff
          font-size: 16px
          color: #333333
          cursor: pointer
        .yxempty_titliston
          border-left: 1px solid #a5e1d6
          border-right: 1px solid #a5e1d6
          border-top: 2px solid $themeColor
          background: #fff
          height: 38px
          line-height: 36px
          margin-top: -2px
          color: $themeColor
    .yx_emptybox
      width: 100%
      font-size: 13px
      text-align: center
      .yx_emptytit
        font-size: 26px
        color: #31a893
        margin-top: 75px
      .yx_EnglishSystem
        margin: 0 auto
        margin-left: 28px
        margin-top: 20px
        div
          width: 284px
          height: 510px
          margin: 20px 3px
          position: relative
        .yx_EnglishSystem1
          background: url(http://file.xdf.cn/neworiental/images/yxEmptybg.png?asd) no-repeat -251px -1255px
          h4
            font-size: 26px
            position: absolute
            top: 55px
            left: 100px
            color: #fff
          .yx_systemlist
            position: absolute
            top: 130px
            left: 12px
            width: 230px
            height: 360px
            text-align: left
            li
              width: 100%
              margin-top: 10px
              h5
                font-size: 14px
                position: relative
                padding-left: 7px
              .color3-4
                color: #f5626b
              p
                line-height: 22px
                color: #666666
                margin-top: 5px
                margin-left: 7px
        .yx_EnglishSystem2
          background: url(http://file.xdf.cn/neworiental/images/yxEmptybg.png?asd) no-repeat -555px -1255px
          h4
            font-size: 26px
            position: absolute
            top: 54px
            left: 96px
            color: #fff
          .yx_systemlist
            position: absolute
            top: 130px
            left: 12px
            width: 230px
            height: 360px
            text-align: left
            li
              width: 100%
              margin-top: 10px
              h5
                font-size: 14px
                position: relative
                padding-left: 7px
              .color4-5
                color: #d1a501
              p
                line-height: 22px
                color: #666666
                margin-top: 5px
                margin-left: 7px
        .yx_EnglishSystem3
          background: url(http://file.xdf.cn/neworiental/images/yxEmptybg.png?asd) no-repeat -852px -1255px
          h4
            font-size: 26px
            position: absolute
            top: 55px
            left: 100px
            color: #fff
          .yx_systemlist
            position: absolute
            top: 130px
            left: 12px
            width: 230px
            height: 360px
            text-align: left
            li
              width: 100%
              margin-top: 10px
              h5
                font-size: 14px
                position: relative
                padding-left: 7px
                .color5-6
                  color: #02a8c3
              p
                line-height: 22px
                color: #666666
                margin-top: 5px
                margin-left: 7px
      .yx_Englishxinzhi
        width: 840px
        height: 124px
        margin: 20px auto
        background: #f5f7fa
        border-radius: 5px
        margin-left: 28px
        .yx_Englishxinzhileft
          font-size: 24px
          color: #ea4e58
          width: 100px
          height: 76px
          border-right: 1px solid #d2d3d4
          padding-top: 7px
          margin-top: 20px
        .yx_Englishxinzhileft span
          display:block
          margin-top: 7px;
        .yx_Englishxinzhiright
          width: 735px
          height: 76px
          margin-top: 27px
          text-align: left
          p
            font-size: 18px
            margin: 0px 0 7px 20px
          ul
            li
              float: left
              margin: 5px 21px
              font-size: 14px
      .yx_emptytit
        font-size: 26px
        color: $themeColor
        margin-top: 75px
      .yx_featurelist
        width: 934px
        margin: 40px auto
        margin-top: 50px
        li
          width: 223px
          height: 210px
          float: left
          p
            font-size: 13px
            color: #666666
            line-height: 20px
            margin-top: 122px
        .yx_featurelist1
          background: url(http://file.xdf.cn/neworiental/images/yxEmptybg.png?asd) no-repeat -210px -2071px
        .yx_featurelist2
          background: url(http://file.xdf.cn/neworiental/images/yxEmptybg.png?asd) no-repeat -450px -2071px
        .yx_featurelist3
          background: url(http://file.xdf.cn/neworiental/images/yxEmptybg.png?asd) no-repeat -685px -2071px
        .yx_featurelist4
          background: url(http://file.xdf.cn/neworiental/images/yxEmptybg.png?asd) no-repeat -918px -2071px
      .yx_Mathtip
        width: 900px
        margin: 0px auto
        margin-top: 46px
        line-height: 28px
        font-size: 16px
        color: #666666
      .yx_Mathtopbox
        width: 850px
        height: 272px
        background: #f5f5f5
        border-radius: 10px
        margin: 0 auto
        margin-top: 20px
        font-size: 16px
        color: #666666
        position: relative
        div
          width: 536px
          height: 240px
          margin: 0px auto
          background: url(http://file.xdf.cn/neworiental/images/yxEmptybg.png?asd) no-repeat -307px -2400px
          position: relative
          p
            position: absolute
            left: 9px
          .yx_Mathtip1
            top: 97px
          .yx_Mathtip2
            top: 160px
          .yx_Mathtip3
            top: 212px
      .yx_Mathmidbox
        width: 850px
        height: 238px
        border-radius: 10px
        margin: 0 auto
        margin-top: 20px
        font-size: 16px
        color: #666666
        position: relative
        i
          position: absolute
          top: 40px
          left: 0
          width: 850px
          height: 60px
          background: url(http://file.xdf.cn/neworiental/images/yxEmptybg.png?asd) no-repeat -240px -1902px
        ul
          width: 100%
          position: absolute
          top: 128px
          left: 10px
          li
            h3
              font-size: 18px
              margin-bottom: 15px
            p
              font-size: 14px
              color: #666666
              margin-top: 7px
          .yx_Mathmid1
            width: 23%
            margin-left: -12px
          .yx_Mathmid2
            width: 51%
          .yx_Mathmid3
            width: 21%
            margin-left: 33px
      .yx_Mathbotbox
        height: 520px
        width: 900px
        border-radius: 10px
        margin: 73px auto 0
        font-size: 16px
        color: #666666
        position: relative
        i
          position: absolute
          top: 40px
          left: 284px
          width: 332px
          height: 332px
          background: url(http://file.xdf.cn/neworiental/images/yxEmptybg.png?asd) no-repeat -1039px -2402px
        h4
          font-size: 16px
          color: #43add3
          position: absolute
          top: 145px
          left: 365px
          line-height: 26px
          span
            font-size: 22px
            margin-bottom: 10px
            display: inline-block
        p
          font-size: 14px
          color: #666666
          padding: 10px 12px
          line-height: 26px
          border-radius: 5px
          position: absolute
        .yx_Mathbot1
          width: 206px
          text-align: right
          background: #fef9e5
          top: -14px
          left: 112px
        .yx_Mathbot2
          width: 210px
          text-align: right
          background: #fbebf1
          top: 130px
          left: 15px
        .yx_Mathbot3
          width: 215px
          text-align: right
          background: #e6eef4
          top: 294px
          left: 40px
        .yx_Mathbot4
          width: 250px
          background: #e8f6fa
          top: 388px
          left: 320px
          text-align: left
        .yx_Mathbot5
          width: 238px
          text-align: left
          background: #e8f8f4
          top: 274px
          left: 611px
        .yx_Mathbot6
          width: 210px
          text-align: left
          background: #fde9eb
          top: 108px
          left: 635px
        .yx_Mathbot7
          width: 209px
          background: #fff1d9
          top: -40px
          left: 555px
      .yx_YuwenSystem
        width: 948px
        margin: 0 auto
        margin-left: 13px
        margin-top: 20px
        div
          width: 285px
          height: 520px
          margin: 0px 2px
          position: relative
          h4
            color: #FFFFFF
            font-size: 16px
            position: absolute
            top: 20px
            left: 10px
            p
              span
                font-size: 20px
                display: block
              em
                font-size: 14px
                display: block
                margin-left: 1px
            .yx_Yuwenleftword
              margin-left: 11px
              margin-top: 0px
            .yx_Yuwenrightword
              margin-left: 30px
              text-align: left
              line-height: 22px
          .yx_systemlistyw
            width: 247px
            position: absolute
            top: 75px
            left: 31px
            li
              width: 100%
              margin-top: 31px
              h5
                font-size: 16px
                width: 20%
                float: left
              .color3-4
                color: #f5626b
              .color5-6
                color: #02a8c3
              .color7-8
                color: #8bad02
              p
                font-size: 15px
                width: 150px
                float: left
                line-height: 28px
                margin-left: 25px
                text-align: left
                margin-top: -3px
          .width160
            left: 29px
            li
              p
                width: 160px
        .yx_YuwenSystem1
          background: url(http://file.xdf.cn/neworiental/images/yxEmptybg.png?asd) no-repeat -233px -20px
        .yx_YuwenSystem2
          background: url(http://file.xdf.cn/neworiental/images/yxEmptybg.png?asd) no-repeat -548px -20px
        .yx_YuwenSystem3
          background: url(http://file.xdf.cn/neworiental/images/yxEmptybg.png?asd) no-repeat -866px -20px
      .yx_Yuwenmidbox
        width: 900px
        height: 450px
        border-radius: 10px
        margin: 0 auto
        font-size: 16px
        color: #666666
        position: relative
        margin-left: 10px
        i
          width: 348px
          height: 265px
          position: absolute
          top: 85px
          left: 277px
          background: url(http://file.xdf.cn/neworiental/images/yxEmptybg.png?asd) no-repeat -529px -776px
        ul
          width: 272px
          li
            width: 272px
            position: absolute
            top: 54px
            left: 10px
            h3
              font-size: 18px
              float: left
              margin-right: 10px
              line-height: 22px
            p
              float: left
              width: 196px
              height: 90px
              border-left: 1px solid #c6c6c6
              color: #666666
              font-size: 14px
              padding-left: 8px
              text-align: left
              line-height: 22px
          .yx_Yuwenmidli1
            h3
              color: #03acc8
          .yx_Yuwenmidli2
            top: 183px
            h3
              color: #ea777e
          .yx_Yuwenmidli3
            top: 310px
            h3
              color: #2bb4b5
            p
              height: 110px
          .yx_Yuwenmidli4
            top: 54px
            left: 637px
            h3
              color: #fb7b43
            p
              width: 150px
          .yx_Yuwenmidli5
            top: 173px
            left: 637px
            h3
              color: #50a6de
            p
              width:185px
              height: 110px
          .yx_Yuwenmidli6
            top: 310px
            left: 637px
            h3
              color: #ec75ad
            p
             width:150px
</style>



// WEBPACK FOOTER //
// src/pages/primaryschool/components/mainfloor/Mainfloor.vue